import { SvgIcon } from '@mui/material';
import './ccf-reverse-audio-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfReverseAudioIconProps  {}

/**
 * Component used to to show reverse audio icon in voicemail
 * @param props - CcfReverseAudioIconProps
 * @example
 * @returns
 */
export function CcfReverseAudioIcon(props: CcfReverseAudioIconProps) {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M9.74445 8.38184e-06C6.8 0.0777862 4.18889 1.42223 2.41111 3.51112L0.944445 2.05556C0.866667 1.97779 0.766667 1.92223 0.655556 1.91112C0.544444 1.8889 0.433333 1.91112 0.333333 1.94445C0.233333 1.9889 0.144444 2.05556 0.0888889 2.15556C0.0333333 2.24445 0 2.34445 0 2.45556V7.22223C0 7.53334 0.244444 7.77779 0.555556 7.77779H5.32222C5.82222 7.77779 6.06667 7.17779 5.71111 6.83334L3.98889 5.10001C5.42222 3.35556 7.57778 2.22223 10 2.22223C14.8 2.22223 18.6 6.60001 17.6222 11.5667C17.0222 14.6445 14.5 17.1 11.4222 17.6445C7.2 18.4 3.44444 15.7111 2.47778 11.9111C2.34444 11.4445 1.9 11.1111 1.41111 11.1111C0.688889 11.1111 0.144444 11.7889 0.322222 12.4778C1.42222 16.8 5.33333 20 10 20C15.6222 20 20.1556 15.3667 20 9.71112C19.8444 4.2889 15.1667 -0.133325 9.74445 8.38184e-06Z"
        fill="#007AB8"
      />
    </SvgIcon>
  );
}

export default CcfReverseAudioIcon;
